<template>
    <div></div>
</template>

<script>
export default {
  created () {
  },
  methods: {
  },
  props: {
  },
  watch: {
  },
  data () {
    return {
    }
  },

}
</script>

<style>

</style>